export enum AlertEnum {
  error = 'error',
  success = 'success',
  info = 'info',
  warning = 'warning',
  neutral = 'neutral',
  entertainment = 'entertainment',
  help = 'help',
}
